"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Purchase = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var Purchase = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Purchase, _super);
    function Purchase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '基金购买';
        _this.code = '106011';
        _this.desc = '基金购买';
        _this.requestParams = new zl_1.PurchaseRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Purchase;
}(service_1.BaseService));
exports.Purchase = Purchase;
//# sourceMappingURL=purchase.js.map